// filepath: src/utils/matrimonyOptions.ts

export type SelectOption = { value: string; label: string };

export const MARITAL_STATUS_OPTIONS: SelectOption[] = [
  { value: "BACHELOR", label: "Bachelor" },
  { value: "DIVORCED", label: "Divorced" },
  { value: "WIDOWED", label: "Widowed" },
];

export const EMPLOYMENT_SECTOR_OPTIONS: SelectOption[] = [
  { value: "PRIVATE", label: "Private" },
  { value: "GOVERNMENT", label: "Government" },
  { value: "BUSINESS", label: "Business" },
  { value: "SELF_EMPLOYED", label: "Self-employed" },
  { value: "FREELANCE", label: "Freelance" },
  { value: "OTHER", label: "Other" },
];

export const FAMILY_TYPE_OPTIONS: SelectOption[] = [
  { value: "Nuclear", label: "Nuclear" },
  { value: "Joint", label: "Joint" },
];

export const FAMILY_STATUS_OPTIONS: SelectOption[] = [
  { value: "Middle Class", label: "Middle Class" },
  { value: "Upper Middle Class", label: "Upper Middle Class" },
  { value: "Rich", label: "Rich" },
];

export const BODY_TYPE_OPTIONS: SelectOption[] = [
  { value: "Average", label: "Average" },
  { value: "Slim", label: "Slim" },
  { value: "Athletic", label: "Athletic" },
  { value: "Heavy", label: "Heavy" },
];

export const SKIN_TONE_OPTIONS: SelectOption[] = [
  { value: "Very Fair", label: "Very Fair" },
  { value: "Fair", label: "Fair" },
  { value: "Wheatish", label: "Wheatish" },
  { value: "Dark", label: "Dark" },
];

export const DIETARY_HABITS_OPTIONS: SelectOption[] = [
  { value: "Vegetarian", label: "Vegetarian" },
  { value: "Non-Vegetarian", label: "Non-Vegetarian" },
  { value: "Eggetarian", label: "Eggetarian" },
  { value: "Jain", label: "Jain" },
];

export const DOSHAM_OPTIONS: SelectOption[] = [
  { value: "NONE", label: "None" },
  { value: "CHEVVAY_DOSHAM", label: "Chevvay Dosham" },
  { value: "NAGA_DOSHAM", label: "Naga Dosham" },
  { value: "KALA_SARPA_DOSHAM", label: "Kala Sarpa Dosham" },
  { value: "RAHU_KETU_DOSHAM", label: "Rahu Ketu Dosham" },
  { value: "OTHERS", label: "Others" },
];

export const NAKSHATRA_OPTIONS: SelectOption[] = [
  { value: "ASHWINI", label: "Ashwini" },
  { value: "BHARANI", label: "Bharani" },
  { value: "KRITHIKA", label: "Krithika" },
  { value: "ROHINI", label: "Rohini" },
  { value: "MRIGASHIRA", label: "Mrigashira" },
  { value: "ARUDRA", label: "Arudra" },
  { value: "PUNARVASU", label: "Punarvasu" },
  { value: "PUSHYA", label: "Pushya" },
  { value: "ASHLESHA", label: "Ashlesha" },
  { value: "MAGHA", label: "Magha" },
  { value: "PURVA_PHALGUNI", label: "Purva Phalguni" },
  { value: "UTTARA_PHALGUNI", label: "Uttara Phalguni" },
  { value: "HASTA", label: "Hasta" },
  { value: "CHITRA", label: "Chitra" },
  { value: "SWATHI", label: "Swathi" },
  { value: "VISHAKA", label: "Vishaka" },
  { value: "ANURADHA", label: "Anuradha" },
  { value: "JYESHTA", label: "Jyeshta" },
  { value: "MOOLA", label: "Moola" },
  { value: "PURVA_ASHADHA", label: "Purva Ashadha" },
  { value: "UTTARA_ASHADHA", label: "Uttara Ashadha" },
  { value: "SHRAVANA", label: "Shravana" },
  { value: "DHANISHTA", label: "Dhanishta" },
  { value: "SHATABHISHA", label: "Shatabhisha" },
  { value: "PURVA_BHADRAPADA", label: "Purva Bhadrapada" },
  { value: "UTTARA_BHADRAPADA", label: "Uttara Bhadrapada" },
  { value: "REVATI", label: "Revati" },
];

export const RASI_OPTIONS: SelectOption[] = [
  { value: "MESHA", label: "Mesha" },
  { value: "VRISHABHA", label: "Vrishabha" },
  { value: "MITHUNA", label: "Mithuna" },
  { value: "KARKATA", label: "Karkata" },
  { value: "SIMHA", label: "Simha" },
  { value: "KANYA", label: "Kanya" },
  { value: "THULA", label: "Thula" },
  { value: "VRISHCHIKA", label: "Vrishchika" },
  { value: "DHANU", label: "Dhanu" },
  { value: "MAKARA", label: "Makara" },
  { value: "KUMBHA", label: "Kumbha" },
  { value: "MEEN", label: "Meen" },
];

export const RELATIONSHIP_OPTIONS = [
  "Son",
  "Daughter",
  "Brother",
  "Sister",
  "Other",
] as const;

export const HIGHEST_EDUCATION_OPTIONS = [
  "High School",
  "Bachelor",
  "Master",
  "PhD",
] as const;

export const RELIGION_OPTIONS: SelectOption[] = [
  { value: "HINDU", label: "Hindu" },
  { value: "MUSLIM", label: "Muslim" },
  { value: "CHRISTIAN", label: "Christian" },
  { value: "SIKH", label: "Sikh" },
  { value: "JAIN", label: "Jain" },
  { value: "BUDDHIST", label: "Buddhist" },
  { value: "PARSI", label: "Parsi" },
  { value: "JEWISH", label: "Jewish" },
  { value: "BAHAI", label: "Bahai" },
  { value: "SPIRITUAL", label: "Spiritual" },
  { value: "ATHEIST", label: "Atheist" },
  { value: "OTHER", label: "Other" },
];

export const SOCIAL_PLATFORM_OPTIONS: SelectOption[] = [
  { value: "FACEBOOK", label: "Facebook" },
  { value: "INSTAGRAM", label: "Instagram" },
  { value: "TWITTER", label: "Twitter" },
  { value: "SNAPCHAT", label: "Snapchat" },
  { value: "LINKEDIN", label: "LinkedIn" },
  { value: "WHATSAPP", label: "WhatsApp" },
  { value: "TELEGRAM", label: "Telegram" },
  { value: "YOUTUBE", label: "YouTube" },
  { value: "SHARECHAT", label: "ShareChat" },
  { value: "MOJ", label: "Moj" },
  { value: "WEBSITE", label: "Website" },
];

export const SMOKING_HABIT_OPTIONS: SelectOption[] = [
  { value: "Non_Smoker", label: "Non Smoker" },
  { value: "Social_Smoker", label: "Social Smoker" },
  { value: "Occasional_Smoker", label: "Occasional Smoker" },
];

export const DRINKING_HABIT_OPTIONS: SelectOption[] = [
  { value: "Non_Drinker", label: "Non Drinker" },
  { value: "Social_Drinker", label: "Social Drinker" },
  { value: "Occasional_Drinker", label: "Occasional Drinker" },
];

export const OWNS_HOUSE_OPTIONS: SelectOption[] = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

/** Look up the human-readable label for a raw enum value. Returns the value itself if no match. */
export const getOptionLabel = (options: SelectOption[], value: string | null | undefined): string => {
  if (!value) return "";
  const found = options.find((o) => o.value === value);
  return found ? found.label : value;
};

export function formatTimeHHMM(time?: string | null): string {
  if (!time) return "";
  // Accepts 'HH:MM:SS' or 'HH:MM' or 'HH:MM:SS.sss'
  const match = /^([0-9]{2}):([0-9]{2})/.exec(time);
  if (match) {
    let hour = Number(match[1]);
    const minute = match[2];
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    if (hour === 0) hour = 12;
    return `${hour}:${minute} ${ampm}`;
  }
  return time;
}
